/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';

export const Spacer = () => {
  return <div className='ml-auto'></div>;
}
